// extracted by mini-css-extract-plugin
export var btnFacebook = "check-module--btn-facebook--d34fd";
export var btnLinkedin = "check-module--btn-linkedin--7c9e2";
export var btnWechat = "check-module--btn-wechat--84e38";
export var btnXing = "check-module--btn-xing--75a7d";
export var btnYoutube = "check-module--btn-youtube--ce7e2";
export var checkWrapper = "check-module--checkWrapper--a04df";
export var disabled = "check-module--disabled--c9cc3";
export var icon = "check-module--icon--abd05";
export var iconText = "check-module--icon-text--35a64";
export var mail = "check-module--mail--7769e";
export var phone = "check-module--phone--ea103";
export var printer = "check-module--printer--7e9c7";